import { render, staticRenderFns } from "./OurServicesBackground.vue?vue&type=template&id=e4fa264c&scoped=true&"
import script from "./OurServicesBackground.vue?vue&type=script&lang=js&"
export * from "./OurServicesBackground.vue?vue&type=script&lang=js&"
import style0 from "./OurServicesBackground.vue?vue&type=style&index=0&id=e4fa264c&scoped=true&lang=css&"
import style1 from "./OurServicesBackground.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fa264c",
  null
  
)

export default component.exports